import React, { useContext } from 'react';
import { Container } from '@mui/material';
import { ErrorBoundary } from '@sentry/react';
import AppRoutes from '../AppRoutes';
import Fallback from './Fallback';

const MainContainer = () => (
  <Container
    component="main"
    id="main"
    maxWidth="xl"
    sx={{
      overflowX: 'hidden',
      margin: 'auto',
      paddingBottom: 4,
      paddingX: { xs: 2, sm: 4, lg: 8, xl: 10 },
      paddingTop: { xs: 10, sm: 12 },
      flexGrow: 1,
    }}
  >
    <ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag('location', 'MainContainer');
      }}
      fallback={<Fallback />}
    >
      <AppRoutes />
    </ErrorBoundary>
  </Container>
);

export default MainContainer;
